<template>
    <div class="overflow-lg-auto teeth-map">
        <div class="row align-items-center width-lg" @mouseup="stopSelecting" @mouseleave="stopSelecting">
            <div class="col-6" v-for="(teethItem, index) in teeth" :key="index">
                <div @mousedown="selecting = true" class="row align-items-start" :class="teethItem.class">
                    <div
                        class="unselectable col p-0 m-0 text-center pointer my-auto tooth-map-element"
                        @mouseover="hover(tooth, $event)"
                        @mousedown="startSelecting(tooth)"
                        @click="view(tooth)"
                        :class="(tooths[tooth] && tooths[tooth].state) ? tooths[tooth].state : ''"
                        v-for="(tooth, indexI) in teethItem.items"
                        :key="indexI"
                    >
                        <div v-if="currentTooth(tooth)">
                                <span
                                    :class="{'badge-warning': selected.indexOf(tooth)>=0, 'badge-light': selected.indexOf(tooth)===-1}"
                                    class="badge badge-pill m-2" v-if="index>=2">
                                    {{ tooth }}
                                    <span v-if="tooths[tooth] && tooths[tooth].treatment && showLabels">
                                        ({{ tooths[tooth].treatment.code }})
                                    </span>
                                </span>
                            <br/>
                            <component
                                :width="width || 50+'px'"
                                :noSegments="true"
                                :redBorder="tooths[tooth] || selected.indexOf(tooth)>=0"
                                :class="[tooths[tooth] || selected.indexOf(tooth)>=0 ? 'red-border-implant' : '']"
                                v-bind:is=" tooths[tooth] && tooths[tooth].state.includes('implant') ? currentTooth(tooth, true) : currentTooth(tooth)"
                            ></component>
                            <br/>
                            <span
                                :class="{'badge-warning': selected.indexOf(tooth)>=0, 'badge-light': selected.indexOf(tooth)===-1}"
                                class="badge badge-pill m-2" v-if="index<2"
                            >
                                {{ tooth }}
                                <span v-if="tooths[tooth] && tooths[tooth].treatment && showLabels">
                                    ({{ tooths[tooth].treatment.code }})
                                </span>
                            </span>
                        </div>
                        <div
                            v-else-if="showConnections"
                            class="connection pointer"
                            :class="{'c-active': selected.indexOf(tooth)>=0 || (tooths[tooth] && tooths[tooth].connection)}"
                        >
                                <span class="badge badge-pill m-2"
                                      :class="{'badge-warning': selected.indexOf(tooth)>=0, 'badge-light': selected.indexOf(tooth)===-1}">
                                </span>
                            <br/>
                            <i class="fe fe-circle"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dentalCharts from '@/components/dentalCharts.ts';
import {modalMixins} from '@/mixins/modal.js'
import {teethComponents, implantTeethComponents} from '@/mixins/all-teeth.js'

export default {
    props: {
        value: {type: Array, default: () => ([])},
        type: null,
        tooths: null,
        width: null,
        kid: null,
        selectable: null,
        showLabels: null,
        showConnections: null,
        connections: null,
        readonly: false,
        isInactiveStyle: false
    },
    mixins: [modalMixins, teethComponents, implantTeethComponents],
    components: {},
    data() {
        return {
            selecting: false,
            startSelectFrom: null,
            currentlyOn: null,
            furthestXY: null,
            data: {},
        }
    },
    watch: {},
    computed: {
        teeth() {
            const chart = dentalCharts.find((item) => {
                return item.value === this.$settings.dentalChart
            })
            return this.kid ? chart.chart.kid : chart.chart.adult
        },
        selected: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
                this.$emit('change', value)
            }
        }
    },
    methods: {

        currentTooth(tooth, implant) {
            let label = implant ? 'implant' : 'tooth';

            if (typeof (tooth) == 'object') tooth = tooth.value;
            tooth = tooth > 50 ? tooth - 40 : tooth;

            if (this.$settings.dentalChart === 'usa')
                tooth = this.$usa2fdi(tooth);

            if (this.$options.components['Tooth' + tooth])
                return label + tooth;
            else
                return 'b-button'
        },

        startSelecting(tooth) {
            if (!this.selectable)
                return
            this.startSelectFrom = tooth
        },

        stopSelecting() {
            this.$emit('hoverTooth', {});
            if (!this.selectable)
                return
            this.selectCrossSection()
            this.selecting = false
            this.startSelectFrom = null
            this.currentlyOn = null
            this.furthestXY = null
        },

        translateToothToXY(tooth) {
            const teethPerGroup = this.teeth[0].items.length
            let partIdx, toothIdx;
            for (const [pIdx, part] of this.teeth.entries()) {
                for (const [tIdx, t] of part.items.entries()) {
                    if (tooth === t) {
                        partIdx = pIdx;
                        toothIdx = tIdx;
                        break;
                    }
                }
            }
            let isTopRow = partIdx < 2;
            let x = toothIdx + (partIdx % 2) * teethPerGroup;
            let y = isTopRow ? 0 : 1;
            return [x, y]
        },

        translateXYtoTooth(x, y) {
            const teethPerGroup = this.teeth[0].items.length
            let partIdx = Math.floor(x / teethPerGroup) + y * 2
            let toothIdx = x % teethPerGroup
            return this.teeth[partIdx].items[toothIdx]
        },

        unselectUnwanted(endX, endY, teeth) {
            if (!this.furthestXY) {
                this.furthestXY = [endX, endY];
                return teeth;
            }
            let [fX, fY] = this.furthestXY
            if (endX < fX || endY < fY) {
                for (let x = endX; x <= fX; x++) {
                    for (let y = endY; y <= fY; y++) {
                        teeth.splice(teeth.indexOf(this.translateXYtoTooth(x, y)), 1)
                    }
                }
            }
            if (endX > fX)
                fX = endX
            if (endY > fY)
                fY = endY
            this.furthestXY = [fX, fY]
            return teeth;
        },

        selectCrossSection() {
            if (this.startSelectFrom === this.currentlyOn)
                return
            let [startX, startY] = this.translateToothToXY(this.startSelectFrom);
            let [endX, endY] = this.translateToothToXY(this.currentlyOn);
            if (startX > endX)
                [startX, endX] = [endX, startX];
            if (startY > endY)
                [startY, endY] = [endY, startY];
            let teeth = this.selected.slice();
            for (let x = startX; x <= endX; x++) {
                for (let y = startY; y <= endY; y++) {
                    teeth.push(this.translateXYtoTooth(x, y))
                }
            }
            teeth = this.unselectUnwanted(endX, endY, teeth)
            this.$emit('input', this.$unique(teeth))
        },

        getBoundingBox(event) {
            let element = event.target;
            if (!event.path) return
            event.path.map(el => {
                if (!el.classList) return {};
                if (el.classList.contains('tooth-map-element'))
                    element = el
            })
            const box = element.getBoundingClientRect()
            const ret = {}
            // Loops through all DomRect properties.
            // Cannot spread because they're not enumerable.
            for (const prop in box) {
                ret[prop] = box[prop]
            }
            ret.xCenter = (box.left + box.right) / 2
            ret.yCenter = (box.top + box.bottom) / 2
            return ret
        },

        hover(tooth, event) {
            let coordinates = this.getBoundingBox(event);
            let hoverObject = {
                tooth: tooth,
                coordinates: coordinates
            }
            this.$emit('hoverTooth', hoverObject);

            if (!this.selecting)
                return
            this.currentlyOn = tooth
            this.selectCrossSection()
        },


        view(tooth) {
            if (this.readonly) return;

            if (this.selectable) {

                let index = this.selected.indexOf(tooth);
                if (index >= 0) {
                    this.selected.splice(index, 1);

                } else {

                    this.selected.push(tooth);
                }
                // this.$set(this.tooths, tooth, { another: true })
                this.$emit('input', this.$unique(this.selected));
                this.$emit('selected-tooth', this.$unique(this.selected))

            } else {

                let toothItem = {
                    tooth,
                    _id: 'temp'
                };
                const {Treatment} = this.$FeathersVuex;
                new Treatment(toothItem);

                this.openModal({
                    id: 'SingleToothModal',
                    tooth: tooth,
                })
            }
        },
    }
}
</script>

<style lang="scss">

svg {
    margin: 0;
}

.red-border-implant .fil0 .filWhite {
    stroke: #e63757 !important;
}

svg:hover .fil0,
svg:hover .filWhite {
    stroke: #f6c343 !important;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);
}

.filRed {
    fill: red;
}

.redBorder {
    stroke: #e63757 !important;
}

.inactive .str1 {
    opacity: .5;
}

.str1 {
    stroke: #95aac9;
    stroke-width: 4;
    stroke-miterlimit: 10;
}

.c-active {
    color: red !important;
}

.connection :hover {
    color: #f6c343;
}

.connection {
    color: #ccc;
}

.filWhite {
    fill: #fff;
    stroke: #ccc;
    stroke-width: 3;
    stroke-linejoin: round;
}


.teeth-map .fil0 {
    fill: #fff;
}

.fil1 {
    fill: #fff;
    stroke: #ccc;
    stroke-width: 1;
    stroke-linejoin: round;
    stroke-dasharray: 3;
}

.fil1:hover {
    fill: #ebf1f6;
    stroke: #ec8c9c;
    stroke-width: 2;
    stroke-dasharray: 0;
    /* zoom: 10; */
}

.active {
    fill: #ec8c9c;
    stroke: #fff;
    stroke-dasharray: 0;
}

.missing .str1 {
    stroke: rgba(0, 0, 0, 0.05) !important;
}

.unselected-tooth .str1 {
    pointer-events: none;
    stroke: rgba(0, 0, 0, 0.05) !important;
}

.implant {
    // background-color: #f6c343;

    // path {
    //     stroke: #95aac9;
    //     stroke-width: 14;
    //     stroke-miterlimit: 10;
    //     fill: #fff;
    //     // content: "I";
    // }
}

@media only screen and (max-width: 1024px) {
    .overflow-lg-auto {
        overflow-y: auto;
    }
    .width-lg {
        min-width: 1024px;
    }
}

@media print {
    .redBorder {
        stroke: #000000 !important;
    }
    .badge-light {
        border: 0;
    }
}
</style>
